<template>
  <div class="authenticating">
    Authenticating...
  </div>
</template>

<script>
import router from '@/router'
import { mapActions } from 'vuex'

export default {
  name: 'Callback',
  data () {
    this.handleAuthentication()
    router.push({ name: 'Home' })

    return {}
  }, 
  methods: mapActions(['handleAuthentication'])
}
</script>